import { useState } from 'react'
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Text,
} from '@ritualco/jutsu'
import { GoogleMapsAutoComplete } from 'components/GoogleMapsAutoComplete'
import { CardPage } from 'components/PageTemplates'
import { FormattedMessage } from 'lib/content/react'

interface AddressViewProps {
  address?: string
  onNext: (placeResult?: google.maps.places.PlaceResult) => void
}

export const AddressView = ({ address, onNext }: AddressViewProps) => {
  const [placeResult, setPlaceResult] = useState<
    google.maps.places.PlaceResult | undefined
  >()

  return (
    <CardPage trackingName="AddressView">
      <Box>
        <Information />
        <Box pt={8}>
          <FormControl id="addressInput">
            <FormLabel>
              <FormattedMessage id="pmportal.onboarding.addressInputLabel" />
            </FormLabel>
            <GoogleMapsAutoComplete
              address={address}
              onChange={pr => setPlaceResult(pr)}
            />
          </FormControl>
          <Text fontSize={'xs'} color={'grayscale.secondary'} mt={2}>
            <FormattedMessage id="pmportal.onboarding.addressCaption" />
          </Text>
        </Box>
        <Flex alignItems={'center'} justifyContent="flex-end" mt={10}>
          <Button
            size="lg"
            disabled={!(placeResult || address)}
            onClick={() => onNext(placeResult)}
          >
            <FormattedMessage id="pmportal.global.actionNext" />
          </Button>
        </Flex>
      </Box>
    </CardPage>
  )
}

const Information = () => (
  <Flex direction={'column'} alignItems={'center'} fontSize={'sm'}>
    <Text>
      <FormattedMessage
        id="pmportal.onboarding.stepXofY"
        values={{ x: 3, y: 3 }}
      />
    </Text>
    <Text fontSize={'3xl'} fontWeight={'bold'} pt={2} pb={2}>
      <FormattedMessage id="pmportal.onboarding.addressTitle" />
    </Text>
    <Text textAlign={'center'} color={'grayscale.secondary'} fontSize={'sm'}>
      <FormattedMessage id="pmportal.onboarding.addressDescription" />
    </Text>
  </Flex>
)
